module.exports = __webpack_public_path__ + "img/Aberdeen_City.38f1136c.png";